import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import {photoSwipe} from "../modulos/photoswipe/photoswipe";
import {premiumTableComment} from '../modulos/premium/premiumTableComment';
import Streaming from "../streaming/streaming";

export const loadZTPage = () => {
    console.log('Loading ZonaTraing Page');

    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    //PhotoSwipe. Galería para aumentar imágenes
    photoSwipe();

    premiumTableComment();

}

